import { render, staticRenderFns } from "./UsergroupPsoDashboard.vue?vue&type=template&id=9af65404"
import script from "./UsergroupPsoDashboard.vue?vue&type=script&lang=js"
export * from "./UsergroupPsoDashboard.vue?vue&type=script&lang=js"
import style0 from "./UsergroupPsoDashboard.vue?vue&type=style&index=0&id=9af65404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports